export default __webpack_public_path__ + "static/ofakim-b1b07c886bc04cbcdea10bcb33064071.png";